<template>
  <DKTeaser :teaser="teaser" :backgroundColor="fragment.background"></DKTeaser>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { DKPageTeaserFragment as DKPageTeaserFragmentModel } from '@/models/DKPageTeaserFragment';
import { DKTeaser } from '@dormakaba/dormakaba-components';
import { Teaser as TeaserModel } from '@/models/Teaser';
import { TeaserStyleType } from '@/models/TeaserStyleType';
import { DKLink } from '@/models/DKLink';

@Component({
  components: {
    DKTeaser,
  },
})
export default class DKPageTeaserFragment extends Vue {
  @Prop() fragment!: DKPageTeaserFragmentModel;

  get pageLink(): DKLink | null {
    return this.fragment?.page.linkedFrom?.[0] || null;
  }

  get teaser(): TeaserModel {
    const links: DKLink[] = [];

    if (this.pageLink) {
      links.push(this.pageLink);
    }

    if (this.fragment?.page.linkResources.length) {
      links.push(...this.fragment.page.linkResources);
    }

    return {
      shortTitle: this.fragment?.shortTitle || '',
      preTitle: this.fragment?.page?.preTitle || '',
      style:
        (this.fragment?.style as TeaserStyleType) ||
        TeaserStyleType.FULL_IMG_TEASER,
      title: this.fragment?.page?.teaserTitle || '',
      image: this.fragment?.page?.headerImage || undefined,
      description: this.fragment?.page?.teaserText || '',
      links,
      assets: this.fragment?.page?.assetResources,
      orientation: this.fragment?.orientation,
    };
  }
}
</script>
